import { PROJECT_TASK_TEMPLATE_TYPES } from 'lib/enums'
import axiosInstance from './axiosInstance'

export const getProjectTemplateSectionById = (sectionId) => {
  return axiosInstance.get(`/project/template-sections/${sectionId}`)
}

export const getProjectTemplateSections = () => {
  return axiosInstance.get('/project/template-sections')
}

export const getProjectTemplateSectionsWithTasks = (type = PROJECT_TASK_TEMPLATE_TYPES.General) => {
  return axiosInstance.get(`/project/template-sections?type=${type}&withTasks=true`)
}

export const createProjectTemplateSection = (data) => {
  return axiosInstance.post('/project/template-sections', data)
}

export const updateProjectTemplateSection = (sectionId, data) => {
  return axiosInstance.put(`/project/template-sections/${sectionId}`, data)
}

export const deleteProjectTemplateSection = (sectionId) => {
  return axiosInstance.delete(`/project/template-sections/${sectionId}`)
}
